export const PASSWORD_REQUIREMENTS = [
  'Longer than 7 characters',
  'Does not match or significantly contain your user name',
];

const normalizeForComparison = (value) =>
  String(value ?? '')
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '');

export const getPasswordUsername = (profile) => {
  const emailLocal = profile?.email?.split('@')?.[0] ?? '';
  const fullName = profile?.fullName ?? '';
  return emailLocal || fullName;
};

export const passwordContainsUsername = (password, username) => {
  const normalizedUser = normalizeForComparison(username);
  const normalizedPass = normalizeForComparison(password);

  if (!normalizedUser || normalizedUser.length < 3) {
    return false;
  }

  return normalizedPass.includes(normalizedUser) || normalizedUser.includes(normalizedPass);
};

export const validateChangePassword = ({
  currentPassword,
  newPassword,
  confirmPassword,
  username,
}) => {
  const errors = {};

  if (!currentPassword?.trim()) {
    errors.currentPassword = 'Current password is required.';
  }

  if (!newPassword?.trim()) {
    errors.newPassword = 'New password is required.';
  } else if (newPassword.length <= 7) {
    errors.newPassword = 'Password must be longer than 7 characters.';
  } else if (passwordContainsUsername(newPassword, username)) {
    errors.newPassword = 'Password must not match or significantly contain your user name.';
  } else if (currentPassword && newPassword === currentPassword) {
    errors.newPassword = 'New password must be different from your current password.';
  }

  if (!confirmPassword?.trim()) {
    errors.confirmPassword = 'Please confirm your new password.';
  } else if (newPassword && newPassword !== confirmPassword) {
    errors.confirmPassword = 'Passwords do not match.';
  }

  return errors;
};
